export default __webpack_public_path__ + "media/images/features/hida/grid-1-019f074f88205a333e4a64c94a327d8f.png";